import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import BusinessIcon from "@material-ui/icons/Business";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import WorkIcon from "@material-ui/icons/Work";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import ReceiptIcon from "@material-ui/icons/Receipt";
import UpdateIcon from "@material-ui/icons/Update";
import ExploreIcon from "@material-ui/icons/Explore";
import AssessmentIcon from "@material-ui/icons/Assessment";
import GroupIcon from "@material-ui/icons/Group";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import HealingIcon from "@material-ui/icons/Healing";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import PortraitIcon from "@material-ui/icons/Portrait";
import SettingsIcon from "@material-ui/icons/Settings";
import { SidebarOptions } from "../@types/sidebarOptions.types";
import TextsmsIcon from "@material-ui/icons/Textsms";
import PublishIcon from "@material-ui/icons/Publish";
import RecentActorsIcon from "@material-ui/icons/RecentActors";
import { CiCalculator1 } from "react-icons/ci";
import { AiFillCalculator } from "react-icons/ai";

export const menuMappings: any = {
	groups_menu: {
		caption: "Groups",
		route: "/",
		icon: () => <BusinessIcon />,
		subTabs: []
	},
	dashboard_menu: {
		caption: "Dashboard",
		route: "/employer",
		icon: () => <SupervisorAccountIcon />,
		subTabs: []
	},
	members_menu: {
		caption: "Members",
		route: "/members",
		icon: () => <SupervisedUserCircleIcon />,
		subTabs: []
	},
	employer_members_menu: {
		caption: "Members",
		route: "/employer/members",
		icon: () => <SupervisedUserCircleIcon />,
		subTabs: []
	},
	plan_control_menu: {
		caption: "Plan Control",
		route: "/",
		icon: () => <AssessmentIcon />,
		subTabsMapping: {
			"Plan Management": "plan_management_sub",
			"Core Open Enrollment": "core_open_enrollment_sub",
			"VEB Open Enrollment": "veb_open_enrollment_sub",
			"Core All Enrollments": "core_all_enrollments_sub",
			"All VEB Enrollments": "all_veb_enrollments_sub"
		},
		subTabs: [
			{
				caption: "Plan Management",
				icon: () => <AssessmentIcon />,
				route: "/employer/plan-management",
				subTabs: []
			},
			{
				caption: "Core Open Enrollment",
				icon: () => <PortraitIcon />,
				route: "/employer/open-enrollment",
				subTabs: []
			},
			{
				caption: "VEB Open Enrollment",
				icon: () => <PortraitIcon />,
				route: "/employer/VEB-open-enrollment",
				subTabs: []
			},
			{
				caption: "Core All Enrollments",
				icon: () => <PortraitIcon />,
				route: "/employer/all-enrollments",
				subTabs: []
			},
			{
				caption: "All VEB Enrollments",
				icon: () => <PortraitIcon />,
				route: "/employer/all-VEB-enrollments",
				subTabs: []
			}
		]
	},
	reports_menu: {
		caption: "Reports",
		route: "/reports",
		icon: () => <ReceiptIcon />,
		subTabs: []
	},
	employer_reports_menu: {
		caption: "Reports",
		route: "/employer/reports",
		icon: () => <ReceiptIcon />,
		subTabs: []
	},
	settings_menu: {
		caption: "Settings",
		route: "/",
		icon: () => <WorkIcon />,
		subTabsMapping: {
			"User Management": "user_management_sub",
			"Document Sharing": "document_sharing_sub",
			"Card Asset Library": "health_card_asset_library_sub",
			"Alert Subscription": "alert_subscription_sub",
			Announcements: "announcements_sub",
			Blogs: "blogs_sub"
		},
		subTabs: [
			{
				caption: "User Management",
				route: "/settings/user-management",
				icon: () => <WorkIcon />,
				subTabs: []
			},
			{
				caption: "Document Sharing",
				route: "/settings/documents",
				icon: () => <WorkIcon />,
				subTabs: []
			},
			{
				caption: "Card Asset Library",
				route: "/settings/health-card-assets",
				icon: () => <CardMembershipIcon />,
				subTabs: []
			},
			{
				caption: "Alert Subscription",
				route: "/settings/alert-subscription",
				icon: () => <WorkIcon />,
				subTabs: []
			},
			{
				caption: "Announcements",
				route: "/settings/announcements",
				icon: () => <WorkIcon />,
				subTabs: []
			},

			{
				caption: "Blogs",
				route: "/settings/blogs",
				icon: () => <WorkIcon />,
				subTabs: []
			}
		]
	},
	employer_settings_menu: {
		caption: "Settings",
		route: "/",
		icon: () => <WorkIcon />,
		subTabsMapping: {
			"User Management": "user_management_sub",
			"Custom Employee Page Design": "custom_employee_page_design_sub",
			"Digital ID Card": "digital_id_card_sub",
			"Card Asset Library": "digital_id_card_sub",
			"Alert Subscription": "alert_subscription_sub",
			Announcements: "announcements_sub",
			Blogs: "blogs_sub"
		},
		subTabs: [
			{
				caption: "User Management",
				route: "/employer/settings/user-management",
				icon: () => <WorkIcon />,
				subTabs: []
			},
			{
				caption: "Custom Employee Page Design",
				icon: () => <PortraitIcon />,
				route: "/employer/member-portal-UI",
				subTabs: []
			},
			{
				caption: "Digital ID Card",
				icon: () => <CardMembershipIcon />,
				route: "/employer/health-card-config",
				subTabs: []
			},
			{
				caption: "Card Asset Library",
				icon: () => <CardMembershipIcon />,
				route: "/employer/health-card-assets",
				subTabs: []
			},
			{
				caption: "Alert Subscription",
				route: "/employer/settings/alert-subscription",
				icon: () => <WorkIcon />,
				subTabs: []
			},
			{
				caption: "Announcements",
				route: "/employer/settings/announcements",
				icon: () => <WorkIcon />,
				subTabs: []
			},

			{
				caption: "Blogs",
				route: "/employer/settings/blogs",
				icon: () => <WorkIcon />,
				subTabs: []
			}
		]
	},
	locations_menu: {
		caption: "Locations",
		route: "/employer/locations",
		icon: () => <ExploreIcon />,
		subTabs: []
	},
	providers_menu: {
		caption: "Providers",
		route: "/employer/providers",
		icon: () => <RecentActorsIcon />,
		subTabs: []
	},
	premium_recalculation_menu: {
		caption: "Premium Recalculation",
		route: "/employer/premiumrecalculation",
		icon: () => <AiFillCalculator size={20} />,
		subTabs: []
	},
	member_info_update_menu: {
		caption: "Member Info Update",
		route: "/employer/member-info-updates",
		icon: () => <UpdateIcon />,
		subTabs: []
	},
	bulk_texting_menu: {
		caption: "Bulk Texting",
		route: "/bulk-text",
		icon: () => <TextsmsIcon />,
		subTabs: []
	},
	veb_data_export_menu: {
		caption: "VEB Data Export",
		route: "/veb-data-export",
		icon: () => <PublishIcon />,
		subTabs: []
	}
	// {
	// 	caption: "Bulk Texting",
	// 	route: "/bulk-text",
	// 	icon: () => <TextsmsIcon />,
	// 	subTabs: []
	// },
	// {
	// 	caption: " VEB Data Export",
	// 	route: "/veb-data-export",
	// 	icon: () => <PublishIcon />,
	// 	subTabs: []
	// }
};
